import React from 'react';

import dynamic from 'next/dynamic';

import { FlexibleDiv } from '@components/formStyles';
import Price from '@components/ui/price';

import { Text } from './styled';
import DiscountedPackagePrice from './DiscountedPackagePrice';

const Box = dynamic(() => import('./styled').then(({ Box }) => Box));
const BoxDesktop = dynamic(() =>
  import('./styled').then(({ BoxDesktop }) => BoxDesktop)
);
const ResponsiveBox = dynamic(() =>
  import('./styled').then(({ ResponsiveBox }) => ResponsiveBox)
);
interface RoomDetailProps {
  title: string;
  price: number;
  currency?: string;
  subText?: string;
  discountPrice?: number;
}

export const RoomDetailBox = ({
  title,
  price,
  currency,
  subText,
  discountPrice,
}: RoomDetailProps) => {
  return (
    <Box>
      <ResponsiveBox>
        <Text size={16.2}>{title}</Text>
        <FlexibleDiv>
          {discountPrice ? (
            <DiscountedPackagePrice
              size={14}
              discountedPrice={discountPrice}
              price={price}
              currency={currency || ''}
            />
          ) : (
            <Price fontSize={36} price={price} currency={currency || ''} />
          )}

          <Text opacity={0.75} size={14}>
            {subText || 'Kişi başı fiyat'}
          </Text>
        </FlexibleDiv>
      </ResponsiveBox>
    </Box>
  );
};

export const RoomDetailBoxDesktop = ({
  title,
  price,
  currency,
  subText,
  discountPrice,
}: RoomDetailProps) => {
  return (
    <BoxDesktop>
      <Text size={16.2}>{title}</Text>
      <FlexibleDiv>
        {discountPrice ? (
          <DiscountedPackagePrice
            size={14}
            discountedPrice={discountPrice}
            price={price}
            currency={currency || ''}
          />
        ) : (
          <Price fontSize={36} price={price} currency={currency || ''} />
        )}
      </FlexibleDiv>
      <Text opacity={0.75} size={14}>
        {subText || 'Kişi başı fiyat'}
      </Text>
    </BoxDesktop>
  );
};
